export enum SubTypeEnum {
  SUB_WEBMASTER = "SUB_WEBMASTER",
  WEBMASTER = "WEBMASTER",
  AGENT = "AGENT"
}